import { TrendingUp, TrendingDown } from 'lucide-react';
import { isBuyDirection } from '../../utils/tradeCalculations';



export const JournalTradeList = ({trade, selectedTrade, updateSelectedTrade, onEdit, onDelete, darkMode}) => {
    const formatProfit = (profit) => {
        try {
          if (profit === null || profit === undefined) return '0.00';
          const numProfit = Number(profit);
          if (isNaN(numProfit)) return '0.00';
          return numProfit.toFixed(2);
        } catch (error) {
          console.error('Error formatting profit:', error);
          return '0.00';
        }
      };
    
      const isPositiveProfit = (profit) => {
        try {
          if (profit === null || profit === undefined) return false;
          const numProfit = Number(profit);
          return !isNaN(numProfit) && numProfit > 0;
        } catch (error) {
          console.error('Error checking positive profit:', error);
          return false;
        }
      };
    
    // Status badge style
    const getStatusBadge = (status) => {
      if (status === 'done') return <span className="px-2 py-1 rounded-full bg-green-900/60 text-green-300 text-xs font-semibold">Done</span>;
      if (status === 'in_progress') return <span className="px-2 py-1 rounded-full bg-blue-900/60 text-blue-300 text-xs font-semibold">In Progress</span>;
      return <span className="px-2 py-1 rounded-full bg-gray-700/60 text-gray-300 text-xs font-semibold">Need Journal</span>;
    };
    
    // Direction badge style
    const getDirectionBadge = (direction) => {
      if (!direction) return null;
      const color = isBuyDirection(direction)
        ? 'bg-green-700/80 text-green-200'
        : 'bg-red-700/80 text-red-200';
      return <span className={`px-2 py-1 rounded font-bold ${color} text-xs mr-2`}>{direction}</span>;
    };
    
    return (
        <div
              key={trade._id}
              className={`w-full rounded-xl border transition-all duration-150 cursor-pointer shadow-sm flex items-stretch
                bg-card border-border hover:shadow-md hover:-translate-y-0.5
                ${selectedTrade?._id === trade._id ? 'ring-2 ring-primary' : ''}
                mb-2`}
              onClick={() => updateSelectedTrade(trade)}
            >
              <div className="flex flex-col p-4 flex-1 min-w-0">
                <div className="flex items-start justify-between w-full">
                  <div className="flex flex-col">
                    <div className="flex items-center mb-1">
                      {getDirectionBadge(trade.direction)}
                      <span className="font-bold text-lg text-foreground mr-2">{trade.symbol}</span>
                    </div>
                    <span className="text-xs text-muted-foreground">{trade.trade_date ? new Date(trade.trade_date).toLocaleDateString() : ''}</span>
                  </div>
                  <div className="flex flex-col items-end">
                    {getStatusBadge(trade.journal_status)}
                  </div>
                </div>
                <div className="flex items-end justify-end mt-4">
                  <div className="flex flex-col items-end">
                    <span className={`font-bold text-2xl flex items-center gap-1 ${isPositiveProfit(trade.profit) ? 'text-green-400' : 'text-red-400'}`}>{
                      isPositiveProfit(trade.profit)
                        ? <TrendingUp className="w-5 h-5 text-green-400" />
                        : <TrendingDown className="w-5 h-5 text-red-400" />
                    }{isPositiveProfit(trade.profit) ? '+' : ''}{formatProfit(trade.profit)}</span>
                    <span className="text-xs text-muted-foreground">{trade.pips ? `${isPositiveProfit(trade.profit) ? '+' : ''}${trade.pips} pips` : ''}</span>
                  </div>
                </div>
              </div>

            </div>
    )
}